import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { Hidden } from "@material-ui/core";
import Card from '@mui/material/Card';
import { ScrollPanel } from 'primereact/scrollpanel';
import { Checkbox } from "primereact/checkbox";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import axios from 'axios'
import { useCookies } from 'react-cookie';
import { useDispatch, useSelector } from 'react-redux'
import {
  getBizID, getBizName, getLogo, getStyle
} from '../../libs/todoSlice'
import { useNavigate, useParams } from 'react-router-dom';
import LoadingComponent from '../../lib/LoadingComponent';
import fontColor from '../../lib/fontColor';
import { getCheckedRedux, setCheckedRedux, getConsentRedux, setConsentRedux, getLoadingRedux, setLoadingRedux } from '../../libs/termAndConditionSlice';
import { getTempCookieRedux } from '../../libs/LoginUserSlice';


function TermAndCondition({ accept, deny }) {
  const businessName = useSelector(getBizName)
  const logo = useSelector(getLogo)
  const style = useSelector(getStyle)
  // const [checked, setChecked] = useState(false);
  const [cookie, setCookie] = useCookies([])
  const dispatch = useDispatch()
  const params = useParams()
  const business_id = useSelector(getBizID)
  // const [ consent, setConsent ] = useState('')
  // const [ loading, setLoading ] = useState(false)

  const consent = useSelector(getConsentRedux)
  const setConsent = (action) => {
    dispatch(setConsentRedux({
      consent: action
    }))
  }

  const loading = useSelector(getLoadingRedux)
  const setLoading = (action) => {
    dispatch(setLoadingRedux({
      loading: action
    }))
  }

  useEffect(() => {
    document.body.classList.add('TermAndCondition');
    return () => {
      document.body.classList.remove('TermAndCondition');
    }
  })

  useEffect(() => {
    if (business_id && localStorage.getItem('account')) {
      getPolicy()
    }
  }, [business_id])

  const tempCookie = useSelector(getTempCookieRedux)
  const getPolicy = async () => {
    setLoading(true)
    await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/user/cmp/policy?biz_id=${business_id}`,
    }).then(({ data, status }) => {
      setConsent(data.data.policy_detail)
      setLoading(false)
    }, ({ response }) => {
      const { status } = response
    })
    setLoading(false)
  }

  return (
    <div
      style={{
        background: '#F8F9FA',
        height: '100vh',
      }}
    >
      <div style={{ padding: '30px 80px 0 80px' }}>
        <img
          // src="/logo_new.png"
          src={`data:image/png;base64, ${logo}`}
          alt=""
          onError={({ target }) => {
            target.src = '/one-platform.png'
          }}
          style={{
            maxHeight: '60px',
            maxWidth: '60px',
            // boxShadow: '2px 2px 6px',
            // borderRadius: '5px'
          }}
        />
        <span
          style={{
            fontWeight: '600',
            color: '#000',
            padding: '10px',
          }}
        >{businessName}</span>
      </div>
      <Hidden xsDown>
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <img
            src="/img_create_path.png"
            style={{
              position: 'fixed',
              width: '670.75px',
              height: '650.54px',
              top: '110px',
            }}
            alt=''
          />
        </div>
      </Hidden>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '60px 40px',
          gap: '36px',
        }}
      >
        <div style={{ zIndex: '1' }}>
          <Card
            style={{
              width: '467px',
              background: 'rgba(0, 0, 0, 0.2)',
              borderRadius: '32px',
              padding: '48px 40px',
              color: '#053075'
            }}
          >
            <div>
              <div>
                <span
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    fontWeight: '700',
                    fontSize: '18px',
                    lineHeight: '50px',
                    letterSpacing: '0.02em',
                    paddingBottom: '10px'
                  }}>ยินดีต้อนรับเข้าสู่ระบบ</span>
              </div>
              <div className="card-croll-panel">
                <ScrollPanel
                  style={{
                    width: '100%',
                    height: '250px',
                  }}
                >
                  <span style={{ fontSize: '14px', fontWeight: '400', lineHeight: '21px', letterSpacing: '0.02em' }}>
                    {loading ?
                      <LoadingComponent />
                      :
                      <div dangerouslySetInnerHTML={{ __html: consent }}></div>
                    }
                  </span>
                  <span>
                  </span>
                </ScrollPanel>
              </div>
              <div
                style={{
                  marginTop: '20px',
                  display: 'flex',
                  gap: '135px',
                  alignSelf: 'stretch'
                }}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                  <Button
                    style={{
                      width: '126px',
                      height: '36px',
                      borderRadius: '6px',
                      display: 'flex',
                      justifyContent: 'center',
                      color: fontColor(style.secondary_color),
                      background: style.secondary_color,
                    }}
                    onClick={() => {
                      accept()
                    }}
                  >
                    รับทราบ
                  </Button>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default TermAndCondition